import React, { Suspense } from "react";
import { colors } from "../../colors";

const LazyLogin = React.lazy(() => import("./login"));

export const LoginRouter = () => {
  return (
    <Suspense
      fallback={<div style={{ width: "100vw", height: "100vh", backgroundColor: colors.memberBg }}></div>}
    >
      <LazyLogin />
    </Suspense>
  );
};
